import { Component, computed, inject, OnInit, signal, Signal, WritableSignal } from '@angular/core';
import { AppFormComponent } from '../../classes/app-form';
import { BoFormsModule } from '@bo/ng-forms';
import { PasswordFieldComponent } from '../forms/password-field/password-field.component';
import { SubmitComponent } from '../forms/submit/submit.component';
import { ValidTokenResponse } from '../../../_interfaces/verify-account';
import { RouterSwitchBtnComponent } from '../router-switch-btn/router-switch-btn.component';
import { Observable, Observer } from 'rxjs';
import { LoaderComponent } from '../loader/loader.component';
import { Store } from '@ngxs/store';
import { GoToStep } from '../../../store/onboarding/onboarding.actions';
import { OnboardingSteps } from '../../../store/onboarding/onboarding.model';

export interface Params {
  id: string;
  code: string;
}
export interface ErrorDetail {
  title: string;
  text: string[];
}

@Component({
  selector: 'app-base-create-password',
  imports: [BoFormsModule, PasswordFieldComponent, SubmitComponent, RouterSwitchBtnComponent, LoaderComponent],
  templateUrl: './create-password.component.html',
})
export abstract class BaseCreatePasswordComponent<T> extends AppFormComponent<T> implements OnInit {
  readonly store = inject(Store);
  protected override fields: Array<string> = ['password', 'password_confirm'];

  abstract formLabel: string;
  abstract resend$?: Observable<T>;
  protected returnBtnCallback?: () => void = undefined;
  protected returnBtnLabel: string = '';

  protected showFieldError: WritableSignal<string> = signal<string>('');
  protected notFound: WritableSignal<boolean> = signal(false);
  protected tokenInvalid: WritableSignal<boolean> = signal(false);
  protected valid: Signal<boolean> = computed<boolean>(() => !(this.notFound() || this.tokenInvalid()));

  abstract invalidDetail: ErrorDetail;
  abstract notFoundDetail: ErrorDetail;

  protected constructor() {
    super();
    this.store.dispatch(new GoToStep(OnboardingSteps.PASSWORD));
  }

  protected validateResponseHandler(): Partial<Observer<ValidTokenResponse>> {
    return {
      next: (value: ValidTokenResponse) => {
        this.tokenInvalid.set(!value.valid);
      },
      error: () => {
        this.notFound.set(true);
      },
    };
  }

  showHelpText(field: string): boolean {
    const formErrors = this.form.controls[field].errors;

    if (formErrors?.['server'] == undefined) {
      return true;
    }
    return formErrors == undefined;
  }
}
